module.exports = __webpack_public_path__ + "img/parter-avatar5.97a7c419.png";